import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';
import { Modal } from '../dialogs/useModal';

export interface EditItemDialogData {
  title: string;
  topic: string;
  description: string;
  responsible: string;
}

export interface EditItemDialogResult {
  topic: string;
  description: string;
  responsible: string;
}

export function EditItemDialog({ modal }: { modal: Modal<EditItemDialogData, EditItemDialogResult> }) {
  const [topic, setTopic] = useState(modal.data.topic);
  const [description, setDescription] = useState(modal.data.description);
  const [responsible, setResponsible] = useState(modal.data.responsible);

  const handleClose = () => modal.close();
  const handleOk = () => modal.close({ topic, description, responsible });

  return (
    <Dialog open={true} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{modal.data.title}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} mt={1}>
          <TextField label="Sak" value={topic} onChange={(e) => setTopic(e.target.value)} autoFocus fullWidth />
          <TextField label="Beskrivelse" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline minRows={2} />
          <TextField label="Ansvarlig" value={responsible} onChange={(e) => setResponsible(e.target.value)} fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Avbryt</Button>
        <Button variant="contained" color="primary" onClick={handleOk} disabled={!topic.trim()}>
          Lagre
        </Button>
      </DialogActions>
    </Dialog>
  );
}
